<template>
  <div>
    <!-- {{fileData}} -->
    <b-form-file style="height: 80px; background: transparent; width: 100%" :otherDocName="otherDocName"
      :documentLink="documentLink" :folderName="'Expense'" :accept="'*'" id="MultiFileUploader"
      :documentName="documentName" :multiple="multiple" :fileAllModuleId="fileAllModuleId" :assign_no="assign_no"
      drop-placeholder="Drop file here..." plain @change="handleFileChange" />
    <div v-for="(ufile, uindex) in uploadedFiles" :key="uindex">
      <a v-if="assign_no" href="javascript:void(0)" @click="viewDoc(ufile)">--View Document - {{ uindex + 1 }}</a>
    </div>
    <div v-for="(file, index) in files" :key="index">
      <div>{{ file.name }}</div>
      <b-progress v-if="file.progress > 0" :variant="'success'" :value="file.progress" :max="100" show-progress
        animated></b-progress>
      <!-- <b-progress :value="file.progress" max="100"></b-progress> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
import AccountService from "../../services/AccountService.js";
export default {
  props: {
    assign_no: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: "",
    },
    documentName: {
      type: String,
      default: "",
    },
    otherDocName: {
      type: String,
      default: "",
    },
    documentLink: {
      type: String,
      default: "",
    },
    folderName: {
      type: String,
      default: "",
    },
    fileAllModuleId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      docURL: URL_BASE_DOC,
      uploadedFiles: [],
      files: [],
      fileData: "",
      fileuploaded: "",
      fileEvent: "",
      presignedUrls: [],
    };
  },
  computed: {
    doc_path() {
      return this.assign_no ? this.assign_no.replaceAll("/", "_") : "";
    }
  },
  methods: {
    getFormatDateTime() {
      // Parse the originalDateTime string into a JavaScript Date object
      // Set originalDateTime to the current date and time
      let originalDateTime = new Date();

      // Extract individual components (optional)
      const year = originalDateTime.getFullYear();
      const month = originalDateTime.getMonth() + 1; // January is 0
      const day = originalDateTime.getDate();
      const hour = originalDateTime.getHours();
      const minute = originalDateTime.getMinutes();

      // Format the date and time as "YYYYMMDDHHmm"
      const formattedDateTime = `${year}${month
        .toString()
        .padStart(2, "0")}${day.toString().padStart(2, "0")}${hour
          .toString()
          .padStart(2, "0")}${minute.toString().padStart(2, "0")}`;

      // Display the formatted date and time
      console.log(formattedDateTime); // Output: "202405021250"
      return formattedDateTime;
    },
    async handleFileChange(event) {
      if (!Array.isArray(this.files)) {
        this.files = [];
      }
      // Support both fresh change events and manual retries without an event
      const fileList = event && event.target && event.target.files ? event.target.files : null;
      if (fileList && fileList.length) {
        for (let i = 0; i < fileList.length; i++) {
          this.files.push({
            name: fileList[i].name,
            progress: 0,
            file: fileList[i],
          });
        }
      }
      // },
      // uploadFiles() {
      const formData = new FormData();
      for (let i = 0; i < this.files.length; i++) {
        // formData.append(`file[${i}]`, this.files[i].file);
        formData.append("file[]", this.files[i].file);
        formData.append(
          "staticFileName",
          this.documentName +
          this.fileAllModuleId +
          "_FileLength_" +
          this.files.length +
          "_" +
          i +
          "_" +
          this.getFormatDateTime()
        );
        formData.append("upload_dir_folderName", this.assign_no?this.assign_no.replaceAll("/", "_"):"");
      }
      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest31_05_2024.php`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
          onUploadProgress: (progressEvent) => {
            for (let i = 0; i < this.files.length; i++) {
              this.files[i].progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            }
          },
        })
        .then(async (response) => {
          console.log("PS response=>", response);
          const resp = response && response.data ? response.data : {};
          this.fileData = resp;
          // Safely extract fields with fallbacks
          this.presignedUrls = Array.isArray(resp.presignedUrlArr) ? resp.presignedUrlArr : [];
          const imgPath = typeof resp.imgPath === "string" ? resp.imgPath : "";
          this.uploadedFiles = imgPath ? imgPath.split(",") : [];
          if (imgPath) {
            eventBus.$emit("fileuploaded", imgPath);
          }
          this.fileEvent = event || null;
          console.log("Files uploaded metadata processed");
          // Only attempt S3 uploads if we actually received pre-signed URLs
          if (this.presignedUrls.length === this.files.length && this.files.length > 0) {
            await this.uploadFiles();
          }
        })
        .catch((error) => {
          console.error(error);
          console.log("Retrying upload...");
          // Retry only the S3 copy if presigned URLs exist; otherwise, do nothing
          setTimeout(() => {
            if (Array.isArray(this.presignedUrls) && this.presignedUrls.length === this.files.length && this.files.length > 0) {
              this.uploadFiles();
            }
          }, 10000);
        })
        .finally(() => {
          // uploadLoader.hide();
        });
    },

    async uploadFiles() {
      try {
        // Iterate through files and upload each one using the corresponding pre-signed URL
        for (let i = 0; i < this.files.length; i++) {
          const file = this.files[i].file;
          const presignedUrl = this.presignedUrls[i];

          // Perform file upload using Axios PUT request
          await this.uploadFileToS3(file, presignedUrl, i);
        }
      } catch (error) {
        console.error("Error uploading files:", error);
      }
    },
    uploadFileToS3(file, presignedUrl, i) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", presignedUrl, true);
        xhr.setRequestHeader("Content-Type", file.type);

        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            const progress = (event.loaded / event.total) * 100;
            file.progress = Math.round(progress);
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve();
            // this.CopyAWSToServer();
          } else {
            reject(`Upload failed with status ${xhr.status}`);
          }
        };

        xhr.onerror = () => {
          reject("Upload failed due to network error.");
        };

        xhr.send(file);
      });
    },
    async uploadFileToS3Bak(file, presignedUrl, index) {
      try {
        const response = await axios.put(presignedUrl, file, {
          headers: {
            "Content-Type": file.type,
          },
          onUploadProgress: (progressEvent) => {
            const progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            this.updateFileProgress(index, progress);
          },
        });
        console.log("File uploaded successfully:", response.data);
      } catch (error) {
        console.error("Error uploading file to S3:", error);
        // Handle upload error
      }
    },
    updateFileProgress(index, progress) {
      this.files[index].progress = progress;
    },
    async CopyAWSToServer() {
      return new Promise((resolve, reject) => {
        AccountService.getAllCopyAWS(this.assign_no.replaceAll("/", "_"))
          .then((response) => {
            const { data, status, statusText } = response;
            console.log("Files AWS Copy =>", data);
            if (status === 200) {
              resolve(data); // Resolve the promise with data if status is 200
            } else {
              reject(statusText); // Reject the promise with statusText if status is not 200
            }
          })
          .catch((error) => {
            console.log("Error in CopyAWSToServer:", error);
            reject(error); // Reject the promise with the caught error
          });
      });
    },
    viewDoc(ufile) {
      if(!ufile) return;
      let key = "ASSIGNMENT_UPLOADS/" + this.doc_path + "/" + ufile;
      this.openSignedDocument(key);
    },
  },
};
</script>
<style>
@media only screen and (min-width: 320px) and (max-width: 767px) {
  #MultiFileUploader {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// MultiFileUploader.vue?6735710c